import { render } from "./AImg.vue?vue&type=template&id=58174b72"
import script from "./AImg.vue?vue&type=script&lang=js"
export * from "./AImg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__